import { render, staticRenderFns } from "./primary.vue?vue&type=template&id=761dd20c&scoped=true&"
import script from "./primary.vue?vue&type=script&lang=js&"
export * from "./primary.vue?vue&type=script&lang=js&"
import style0 from "./primary.vue?vue&type=style&index=0&id=761dd20c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761dd20c",
  null
  
)

export default component.exports